"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FlagIcon;

var _propTypes = require("prop-types");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _CountryCodes = require("./CountryCodes");

var _CountryCodes2 = _interopRequireDefault(_CountryCodes);

var _Flag = require("./internal/Flag");

var _Flag2 = _interopRequireDefault(_Flag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

FlagIcon.propTypes = { size: _propTypes.number, code: (0, _propTypes.oneOf)(_CountryCodes2.default).isRequired };

FlagIcon.defaultProps = { size: 24 };

function FlagIcon(_ref) {
  var code = _ref.code,
      props = _objectWithoutProperties(_ref, ["code"]);

  if (!_CountryCodes2.default.includes(code)) {
    return null;
  }

  // eslint-disable-next-line global-require, import/no-dynamic-require
  var src = require("../assets/" + code + ".svg");

  return _react2.default.createElement(_Flag2.default, _extends({}, props, { src: src, alt: code }));
}